const MarginCenter = ({ children }) => {
    return (
        <div className="margin-inline-auto">
            {children}
        </div>
    )
}

export default MarginCenter;